import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import customIconUrl from "../../assets/marker.svg";

const customIcon = new L.Icon({
  iconUrl: customIconUrl,
  iconSize: [40, 31],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
  shadowSize: [41, 41],
});

const CustomMarker = ({ marker, handleMarkerClick }) => {
  return (
    <Marker
      position={marker.position}
      icon={customIcon}
      eventHandlers={{
        click: () => handleMarkerClick(marker),
      }}
    >
      <Popup>
        <>
          <p>Selected Marker Details:</p>
          <p>Latitude: {marker.position.lat}</p>
          <p>Longitude: {marker.position.lng}</p>
          <p>Address: {marker.address || "Loading address..."}</p>
          <p>Tipo de incidencia: {marker.tipoincidencia}</p>
          <p>Estado: {marker.estado === 1 ? "Activo" : "Atendido"}</p>
        </>
      </Popup>
    </Marker>
  );
};

export default CustomMarker;